const UnitsOfMeasure = () => import("Core/configuration/units_of_measure/views/UnitsOfMeasure");
const UnitsOfMeasureForm = () => import("Core/configuration/units_of_measure/views/UnitsOfMeasureForm");

export default {
    children: [
        {
            path: "configuration/units_of_measure",
            name: "units_of_measure",
            component: UnitsOfMeasure,
            meta: {
                requiresAuth: true,
                title: "lang.units_of_measure",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/unit_of_measure/:id?",
            name: "unit_of_measure",
            component: UnitsOfMeasureForm,
            meta: {
                requiresAuth: true,
                title: "lang.units_of_measure",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
